import InputField from '../../../../component/form/FormInput';
import { getDate } from '../../../../utils/dateUtils';
const PaymentMadeProductTable = ({
	isDisabled,
	handleClearAppliedAmount,
	productTableData,
	id,
	errors = [],
	tableColumns,
	handlePaymentChange,
	handleFullPaymentToggle,
	calculateTotalPayment,
	type,
}) => {
	return (
		<div
			style={{ margin: '20px 16px' }}
			className="max-w-1297"
		>
			<p
				style={{
					float: 'right',
					display: 'block',
					borderBottom: '1px solid #3B58FF',
					color: '#3B58FF',
					fontWeight: 'bold',
					cursor: isDisabled ? 'not-allowed' : 'pointer',
				}}
				onClick={handleClearAppliedAmount}
			>
				Clear Applied Amount
			</p>
			<table
				style={{ borderCollapse: 'collapse', marginTop: '20px' }}
				className="max-w-1297"
			>
				<thead>
					<tr style={{ backgroundColor: '#f1f3f5', fontWeight: 'bold', color: '#555B67' }}>
						{tableColumns.map((col, index) => (
							<th
								key={index}
								style={{
									padding: '8px',
									border: '1px solid #dee2e6',
									textAlign: col === 'Date' || col === 'Bill#' || col === 'PO#' ? 'left' : 'right',
								}}
							>
								{col}
							</th>
						))}
					</tr>
				</thead>
				<tbody style={{ color: '#555B67', fontWeight: 'bold' }}>
					{productTableData?.map((pb, index) => (
						<tr
							key={index}
							style={{
								backgroundColor: index === 1 ? '#f0f8ff' : 'transparent',
								height: '97px',
							}}
						>
							{type === 'pm' && (
								<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'left' }}>
									{pb?.date !== null ? getDate(pb.date) : ''}
									<br />
									<span style={{ fontSize: '12px' }}>
										Due Date:{' '}
										<span style={{ color: '#000000', fontWeight: 'bold' }}>
											{pb?.purchase_bill?.due_date !== null && pb?.purchase_bill?.due_date !== ''
												? getDate(pb?.due_date || pb?.purchase_bill?.due_date)
												: ''}
										</span>
									</span>
								</td>
							)}

							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'left' }}>
								{pb?.bill_number}
							</td>
							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'left' }}>
								{pb?.purchase_order_number}
							</td>
							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right' }}>
								{pb?.bill_amount}
							</td>
							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right' }}>
								{isNaN(id) ? pb?.due_amount : pb?.bill_amount}
							</td>
							<td style={{ border: '1px solid #dee2e6', padding: '8px', textAlign: 'right' }}>
								<div
									style={{
										marginTop: '4px',
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
										width: '100%',
									}}
								>
									<InputField
										type="text"
										value={type === 'cn' ? pb.excess_paid_amount : pb?.paid_amount}
										placeholder="0.00"
										onChange={(valueData) => {
											var value = valueData?.replace(/[^0-9.]/g, '');
											handlePaymentChange(index, value);
										}}
										style={{ width: '165px', textAlign: 'right' }}
										error={
											errors.filter((data) => data.index === index && data.error !== '').length > 0
												? errors
														.filter((data) => data.index === index && data.error !== '')
														.map((item) => item.error)
												: false
										}
									/>
								</div>

								<div
									style={{
										cursor: 'pointer',
										marginTop: '4px',
										display: 'flex',
										justifyContent: 'flex-end',
										alignItems: 'center',
										width: '100%',
									}}
								>
									<p
										style={{
											borderBottom: '1px solid #3B58FF',
											fontSize: '12px',
											color: '#3B58FF',
											fontWeight: 'bold',
											whiteSpace: 'nowrap',
											cursor: 'pointer',
										}}
										onClick={() => {
											if (pb?.paid_amount === pb?.due_amount) {
												handleFullPaymentToggle(index, 'clear');
											} else {
												handleFullPaymentToggle(index, 'pay');
											}
										}}
									>
										{pb?.paid_amount === pb?.due_amount ? 'Clear Amount' : 'Pay in Full'}
									</p>
								</div>
							</td>
						</tr>
					))}
				</tbody>
			</table>
			{/* Total Section */}
			<div
				style={{
					display: 'flex',
					justifyContent: 'flex-end',
					alignItems: 'center',
					padding: '10px',
					backgroundColor: '#f8f9fa',
					border: '1px solid #dee2e6',
				}}
			>
				<div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
					<span style={{ fontWeight: 'bold', color: '#555B67' }}>Total :</span>
					<span style={{ fontWeight: 'bold' }}>
						₹ {calculateTotalPayment()?.toFixed(2) || 'N/A'}
					</span>
				</div>
			</div>
			{/* Summary Section */}
		</div>
	);
};
export default PaymentMadeProductTable;
